/**
 * Renders in the theme that André designed,
 * but with a more modern twist.
 * TODO Implement.
 *
 * @type {import("../useFormTheme").FormTheme}
 */
const modern = {
    form: {
        backgroundColor: 'white',
        border: 1,
        borderColor: 'border',
        paddingX: 3,
        paddingY: 4,
    },
    fieldLayout: {
        backgroundColor: 'nuanced',
        borderTopLeftRadius: 'large',
        borderTopRightRadius: 'large',
        marginBottom: 2,
        padding: 2,
        marginRight: 'auto',
        width: 'auto',
    },
    label: {},
    field: {},
    input: {
        backgroundColor: 'transparent',
        border: 0,
        borderBottom: 1,
        borderColor: 'border',
        boxShadow: 'none',
        ':focus': {
            outline: 'none',
            borderColor: 'primary',
            boxShadow: (theme) => { var _a; return `0 1px ${(_a = theme.colors) === null || _a === void 0 ? void 0 : _a.primary}`; },
        },
    },
    textArea: {},
    checkbox: {},
    radio: {},
    description: {},
    warning: {},
    error: {},
};
export default modern;
//# sourceMappingURL=modern.js.map